import { IColumnaServiceMock } from "@/services";

export const mockColumnaService = (): IColumnaServiceMock => ({
  _fetch: jest.fn(),
  _save: jest.fn(),
  _fetchConfColumnasPais: jest.fn(),
  _saveConfColumnasPais: jest.fn(),
});
